import React from "react";
import { cn } from "@/src/lib/utils";

export const Button = React.forwardRef(
  ({ children, className, variant = "primary", size = "md", ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "w-full font-semibold uppercase tracking-wide transition-all duration-200 active:scale-[0.98] disabled:opacity-40 disabled:pointer-events-none min-h-[44px] flex items-center justify-center",
          {
            "bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-glow":
              variant === "primary",
            "bg-secondary text-secondary-foreground border border-border hover:bg-muted hover:border-primary/30":
              variant === "secondary",
            "bg-transparent text-muted-foreground hover:text-foreground hover:bg-secondary":
              variant === "ghost",
            "bg-success/15 text-success border border-success/30 hover:bg-success/25":
              variant === "success",
            "bg-destructive/15 text-destructive border border-destructive/30 hover:bg-destructive/25":
              variant === "destructive",
          },
          {
            "text-xs py-2 px-3 rounded-lg": size === "sm",
            "text-sm py-3 px-5 rounded-xl": size === "md",
            "text-base py-4 px-6 rounded-xl": size === "lg",
          },
          className
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";
